export default __webpack_public_path__ + "static/media/Windpiercer.a5f66d26.jpg";